import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import styled, { withTheme } from 'styled-components';
import InputTip from 'components/atoms/form/InputTip';
import StyledLabel from 'components/atoms/inputs/Label';

const StyledValue = styled.h4`
     font-family: Lato;
     font-size: 14px;
     color: ${props => (props.color ? props.color : props.theme.forms.subheader)};
`;

class ViewEntityAdvancedSetting extends Component {
    render() {
        const { showFlag, brandName, overrideBrandFlag, displayName } = this.props;
        let brandOverrideCopy;
        const showBrandOverrideCopy = brandName;
        if (showBrandOverrideCopy) {
            if (overrideBrandFlag) {
                brandOverrideCopy = `Entity overrides ${brandName} Brand Show '${displayName}' setting.`;
            } else {
                brandOverrideCopy = `Inherited Show '${displayName}' setting from ${brandName} Brand.`;
            }
        }

        return (
            <React.Fragment>
                <StyledLabel>{displayName}</StyledLabel>

                <Row>
                    <Col xs={12}>
                        <StyledValue color={showFlag ? this.props.theme.colors.positive : this.props.theme.colors.darkgray} >{showFlag ? 'Enabled' : 'Disabled'}</StyledValue>
                        {showBrandOverrideCopy && <InputTip>{brandOverrideCopy}</InputTip>}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default withTheme(ViewEntityAdvancedSetting);



// WEBPACK FOOTER //
// ./src/components/molecules/ViewEntityAdvancedSetting.js